import { jsx as _jsx } from "react/jsx-runtime";
import { CustomTextField, ErrorIcon } from '../subcomponents';
import getTranslation from '../../../helpers/get-translation';
var DateOfBirthInput = function (_a) {
    var dateValue = _a.dateValue, error = _a.error, handleOnChange = _a.handleOnChange, handleOnBlur = _a.handleOnBlur;
    var _b = getTranslation(), birthDateHelpText = _b.birthDateHelpText, birthDatePlaceholder = _b.birthDatePlaceholder;
    var onChange = function (event) {
        var value = event.target.value;
        handleOnChange(value);
    };
    return (_jsx(CustomTextField, { id: "birth-date", autoCapitalize: "none", name: "birth-date", placeholder: birthDatePlaceholder, helpText: birthDateHelpText, error: error, type: "text", value: dateValue, errorIcon: _jsx(ErrorIcon, {}), onChange: onChange, onBlur: handleOnBlur, width: 100, maxLength: 10 }));
};
export default DateOfBirthInput;
